import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-restore-order-dialog',
  templateUrl: './restore-order.dialog.html',
  styleUrls: ['./restore-order.dialog.scss'],
  standalone: false,
})
export class RestoreOrderDialog implements OnInit {
  @Output() onRestore = new EventEmitter();
  count: number = 0;

  constructor(
    public dialogRef: MatDialogRef<RestoreOrderDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.count = this.data.count;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onRestoreClick(): void {
    this.onRestore.emit();
    this.dialogRef.close();
  }
}
